export interface Payment {
    prepayment: number;
    COD: number;
    total: number;
    paymentType: PaymentType;
}

export enum PaymentType {
    ONLINE = 'Online',
    ADVANCE_PAYMENT = 'AdvancePayment',
}
